import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=08e892fd&scoped=true&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=08e892fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e892fd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08e892fd')) {
      api.createRecord('08e892fd', component.options)
    } else {
      api.reload('08e892fd', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=08e892fd&scoped=true&", function () {
      api.rerender('08e892fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/monitoring/Dashboard.vue"
export default component.exports